export var getImages = function getImages(mediaObj) {
  var images = mediaObj.images;
  var frontImage = images.find(function (img) {
    return img.match(/E001/g);
  });
  var sideImage = images.find(function (img) {
    return img.match(/E002/g);
  });
  return [frontImage, sideImage];
};